import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../../core/util/apifeatures';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { CRBTUIComponentProps, CRBTUIComponent } from '../../crbt/crbtuicomponent';
import { DedicateFlashMessageCSSStyleImpl } from './dedicateflashmessagecss';
import { DedicateFlashMessageViewImpl } from './dedicateflashmessageview';
import { DedicateFlashMessageToneViewModelImpl } from './dedicateflashmessageviewmodel';
import { FlashMessageSubscriptionDetailsAPIModel, FlashMessageSubscriptionDetailsAPIModelImpl } from '../flashmessagesubscriptiondetails/flashmessagesubscriptiondetailsapimodel';
import { DedicateFlashDto } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';
import { AlertType } from '../../../../toolkit/alert/alerttype';

export interface DedicateFlashMessageComponentProps extends CRBTUIComponentProps
{
   
}

export interface DedicateFlashMessageComponentHandler extends UIComponentHandler
{
    onDataNotLoaded(isNotLoaded: boolean): void;
    onDeleteDedicateClicked(flashDto: DedicateFlashDto): void;
    
}
export interface  DedicateFlashMessageComponentState extends UIComponentState
{
    isDataNotLoaded: boolean;
}

export class DedicateFlashMessageComponent extends CRBTUIComponent<DedicateFlashMessageComponentProps, DedicateFlashMessageComponentState> 
implements DedicateFlashMessageComponentHandler
{
    private DedicateFlashMessageViewModel: DedicateFlashMessageToneViewModelImpl;

    constructor(props: DedicateFlashMessageComponentProps)
    {
        super(props);
        this.onDeleteDedicateClicked = this.onDeleteDedicateClicked.bind(this);
        this.DedicateFlashMessageViewModel = new DedicateFlashMessageToneViewModelImpl(
            this.props.context, this.onDeleteDedicateClicked);
        this.DedicateFlashMessageViewModel.setListDatas([]);
        this.state ={isDataNotLoaded:false};
    }
     onDataNotLoaded(isNotLoaded: boolean): void 
     {
        this.setState({isDataNotLoaded: isNotLoaded});
     }

     componentDidMount()
       {
            if(this.props.context.getUserContext().getIsLoggedIn())
            {
                (this.getView() as DedicateFlashMessageViewImpl).showLoader();
               
                (this.getAPIModel() as FlashMessageSubscriptionDetailsAPIModel).getDedicateFlashDetails();
            }
       }

       componentWillReceiveProps(nextProps: DedicateFlashMessageComponentProps)
       {
            if(this.props.context.getUserContext().getIsLoggedIn())
            {
                (this.getView() as DedicateFlashMessageViewImpl).showLoader();
                (this.getView() as DedicateFlashMessageViewImpl).setListOfDatas([]);
                
                this.setState({isDataNotLoaded: false});
                
                (this.getAPIModel() as FlashMessageSubscriptionDetailsAPIModel).getDedicateFlashDetails();
            }
       }
   
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new DedicateFlashMessageViewImpl(this.DedicateFlashMessageViewModel, applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new DedicateFlashMessageCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
        return new FlashMessageSubscriptionDetailsAPIModelImpl(applicationContext, apiModelHandler);
    }

    onDeleteDedicateClicked(flashDto: DedicateFlashDto): void {
        (this.getView() as DedicateFlashMessageViewImpl).showLoader();
        (this.getAPIModel() as FlashMessageSubscriptionDetailsAPIModel).deleteDedicateFlashMessage(flashDto);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as DedicateFlashMessageViewImpl).dismissLoader();

        console.log("(data as DedicateFlashDto[]): " + JSON.stringify((data as DedicateFlashDto[])));
        if(feature === APIFeatures.GET_DEDICATE_FLASH_MESSAGE)
        {
            this.DedicateFlashMessageViewModel.setListDatas((data as DedicateFlashDto[]));
           this.setState({ isDataNotLoaded:   this.DedicateFlashMessageViewModel.getListOfDatas().length > 0 ? false :  true});

        }
        else if(feature === APIFeatures.DELETE_DEDICATE_FLASH_MESSAGE)
        {
          let listofDatas = this.DedicateFlashMessageViewModel.getListOfDatas().filter((data1: any) =>
            {
                return data1.id !== (data as DedicateFlashDto).getId();
            });
            this.DedicateFlashMessageViewModel.setListDatas(listofDatas);
           this.setState({ isDataNotLoaded:   this.DedicateFlashMessageViewModel.getListOfDatas().length > 0 ? false :  true});

            (this.getView() as DedicateFlashMessageViewImpl).showPopup(this.getContext().getResources().getString(Strings.flash_message_delete_success),AlertType.SUCCESS);
        }

        window.scroll(0,0);
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("onFailure: " + feature);
        (this.getView() as DedicateFlashMessageViewImpl).dismissLoader();

        if(feature === APIFeatures.GET_DEDICATE_FLASH_MESSAGE)
        {
            this.DedicateFlashMessageViewModel.getListOfDatas().length = 0;
            this.setState({ isDataNotLoaded: true});
        }
        else if(feature === APIFeatures.DELETE_DEDICATE_FLASH_MESSAGE)
        {
            (this.getView() as DedicateFlashMessageViewImpl).showPopup(description,AlertType.ERROR);
        }
        
    
        window.scroll(0,0);
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/dedicateflashmessage/dedicateflashmessagecomponent.tsx